import React from 'react';
import { Page, Text, InlineStack } from '@shopify/polaris';
import { TitleBar } from '@shopify/app-bridge-react';

/**
 * Contact button handlers
 * These open in new tabs as per user requirements
 */
const handleEmailClick = () => {
  window.open('https://apps.shopify.com/lift-crowdfunding-presales#modal-show=GetSupportModal', '_blank');
};

const handleWhatsAppClick = () => {
  window.open('https://wa.me/919920919407', '_blank');
};

export default function PageTitleBar({ 
  title, 
  subtitle, 
  primaryAction,
  secondaryActions = []
}) {
  return (
    <>
      {/* TitleBar component from @shopify/app-bridge-react */}
      {/* According to App Bridge 4.x docs: https://shopify.dev/docs/api/app-bridge-library/react-components/titlebar-component */}
      {/* Children should be native <button> elements with onClick handlers */}
      <TitleBar title={title || ''}>
        {/* Contact buttons - Email and WhatsApp as primary buttons */}
        <button variant="secondary" onClick={handleEmailClick}>
          Contact Email
        </button>
        <button variant="secondary" onClick={handleWhatsAppClick}>
          Contact WhatsApp
        </button>
        
        {/* Custom secondary actions */}
        {secondaryActions.map((action, index) => (
          <button
            key={index}
            onClick={action.onAction}
            disabled={action.disabled}
          >
            {action.content || action.label}
          </button>
        ))}
        
        {/* Additional primary action if provided */}
        {primaryAction && (
          <button
            variant="primary"
            onClick={primaryAction.onAction}
            disabled={primaryAction.disabled}
          >
            {primaryAction.content || primaryAction.label}
          </button>
        )}
      </TitleBar>
    </>
  );
}

